import {createSlice} from '@reduxjs/toolkit';

import {ISelectionSlice} from '../types';

const initialState: ISelectionSlice = {};

// Row-selection slice factory (FNP-951). One slice per module, keyed by the
// module's entity key. Matches the factory the other platform apps use, so a
// module's selection code reads the same in every repo.
export const SelectionSliceFor = (entityKey: string) => {
    return createSlice({
        name: entityKey,
        initialState,
        reducers: {
            addToSelection: (state, action) => {
                const record = action.payload;
                state[record.id] = record;
            },
            removeFromSelection: (state, action) => {
                delete state[action.payload];
            },
            clearSelection: (state) => {
                Object.keys(state)
                      .forEach((key) => {
                          delete state[key];
                      });
            },
        },
    });
};
